import { Component, Input, OnInit } from '@angular/core';
import { ApiService } from 'src/app/core/backend/api.service';
import { SopoLoadingService } from 'src/app/shared/services/sopo-loading/sopo-loading.service';
import { WaitingPlayerItem } from 'src/app/club/pages/waiting-player-item/waiting-player-item.page';
import { GameServerStatus } from '@soposopo/sopo-models';
import { firstValueFrom } from 'rxjs';
import { DEFAULT_DISMISS_AFTER_TIME, SopoPopupService } from 'src/app/sopo-popup/service/sopo-popup.service';

@Component({
    selector: 'waiting-list',
    templateUrl: './waiting-list.component.html',
    styleUrls: ['./waiting-list.component.scss'],
    standalone: false
})
export class WaitingListComponent implements OnInit {
    @Input() myID = '';
    @Input() clubID = '';
    @Input() tableID = '';
    @Input() waitinglist: string[] = [];
    @Input() gameServer: GameServerStatus = {
        state: 'UnAllocated',
        gameServerName: '',
    };

    gameServerUrl = '';
    waitingPlayersOpened = false;
    buttonClicked = false;

    constructor(
        private apiService: ApiService,
        private loadingService: SopoLoadingService,
        private sopoPopupService: SopoPopupService,
    ) {}

    ngOnInit() {
        this.gameServerUrl = ApiService.resolveGameServerUrl(this.gameServer);
    }

    showWaitingPlayers(tableId: string, event: any) {
        event.stopImmediatePropagation();
        if (this.waitingPlayersOpened) return;
        this.waitingPlayersOpened = true;
        const waitingPlayersRef =  this.sopoPopupService.openDialog('app', WaitingPlayerItem, {
            closeButton: true,
            data: { tableId: tableId },
        });

        firstValueFrom(waitingPlayersRef.afterClosed).then(() => {
            this.waitingPlayersOpened = false;
        });
    }

    joinWaitingList(tableID: string, event: any) {
        event.stopImmediatePropagation();
        if (this.buttonClicked) return;
        this.buttonClicked = true;
        if (this.gameServerUrl === '') return;
        const payload = {
            tableID: tableID,
            userID: this.myID,
        };
        this.loadingService.present('api');
        this.apiService
            .joinWaitingList(payload, this.gameServerUrl)
            .then(
                (response) => {
                    this.buttonClicked = false;
                    this.sopoPopupService.clearViewContainer('app');
                    this.sopoPopupService.showAlert('app', {
                        header: response.header,
                        message: response.message,
                        dismissAfter: DEFAULT_DISMISS_AFTER_TIME,
                        sCss: ['sopo-popup-red-background'],
                    });
                },
                (error) => {
                    this.buttonClicked = false;
                    const header = error.error.header
                        ? error.error.header
                        : 'Waiting List';
                    const message = error.error.message
                        ? error.error.message
                        : 'Join waiting list failed.';
                    this.sopoPopupService.clearViewContainer('app');
                    this.sopoPopupService.showAlert('app', {
                        header,
                        message,
                        dismissAfter: DEFAULT_DISMISS_AFTER_TIME,
                        sCss: ['sopo-popup-red-background'],
                    });
                }
            )
            .finally(() => {
                this.buttonClicked = false;
                this.loadingService.dismiss('api');
            });
    }

    leaveWaitingList(tableID: string, event: any) {
        event.stopImmediatePropagation();
        if (this.buttonClicked) return;
        this.buttonClicked = true;
        if (this.gameServerUrl === '') return;
        const payload = {
            tableID: tableID,
            userID: this.myID,
        };
        this.loadingService.present('api');
        this.apiService
            .leaveWaitingList(payload, this.gameServerUrl)
            .then(
                (response) => {
                    this.buttonClicked = false;
                    this.sopoPopupService.clearViewContainer('app');
                    this.sopoPopupService.showAlert('app', {
                        header: response.header,
                        message: response.message,
                        dismissAfter: DEFAULT_DISMISS_AFTER_TIME,
                        sCss: ['sopo-popup-red-background'],
                    });
                },
                (error) => {
                    this.buttonClicked = false;
                    const header = error.error.header
                        ? error.error.header
                        : 'Waiting List';
                    const message = error.error.message
                        ? error.error.message
                        : 'Leave waiting wist failed.';
                    this.sopoPopupService.clearViewContainer('app');
                    this.sopoPopupService.showAlert('app', {
                        header,
                        message,
                        dismissAfter: DEFAULT_DISMISS_AFTER_TIME,
                        sCss: ['sopo-popup-red-background'],
                    });
                }
            )
            .finally(() => {
                this.buttonClicked = false;
                this.loadingService.dismiss('api');
            });
    }

    isAlreadyWaiting(waitinglist: string[]) {
        if (waitinglist.find((id) => id == this.myID)) {
            return true;
        }
        return false;
    }
}
